<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-14 19:12:19
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2022-10-24 17:36:24
 * @FilePath: /bpm-form/src/components/wgForm/widget-items/wg-input.vue
 * @Description: 描述
 -->
<template>
    <div :title="formatValue" widget-type="number">
        <!-- 使用format 需要同步使用change事件 blur事件获取值为转化后的值 -->
        <!-- :formatter="text => `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" // 增加语言限制
    -->
        <a-input-number
            v-if="!disabled"
            v-model="text"
            :size="size"
            :data-model="fieldName"
            :max="options.max"
            :min="options.min"
            :disabled="disabled"
            :formatter="
                (text) => `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :placeholder="disabled ? '' : placeholder"
            :step="options.step"
            :precision="options.precision"
            :class="options.customClass"
            @blur="handleChange"
        />
        <a-input-number
            v-else
            :value="formatValue"
            :size="size"
            :data-model="fieldName"
            :max="options.max"
            :min="options.min"
            :disabled="true"
            :step="options.step"
            :precision="options.precision"
            :class="options.customClass"
        />
    </div>
</template>
<script>
import numeral from 'numeral';
import baseMixin from '../../lib/baseMixin';

export default {
    mixins: [baseMixin],
    data() {
        return {
            options: {
                width: '100%',
                format: '',
                required: false,
                defaultValue: null,
                precision: null,
                min: Number.MIN_SAFE_INTEGER,
                max: Number.MAX_SAFE_INTEGER,
                step: 1,
                disabled: false,
                controlsPosition: '',
                customClass: '',
                labelWidth: 100,
                isLabelWidth: false,
                hidden: false,
                dataBind: true,
                remoteFunc: '',
                remoteOption: '',
            },
            lastVal: 0,
        };
    },
    computed: {
        formatValue() {
            if (this.options.format) {
                if (this.text || this.text === 0) {
                    return numeral(this.text).format(this.options.format);
                }
                return null;
            }
            return this.text;
        },
    },
    methods: {
        initVal(val) {
            this.text = this.valueToNumber(val);
        },
        handleChange(e) {
            const val = e.target.value || this.defaultValue;
            const newVal = this.valueToNumber(val?.replace(/(,*)/g, '')); // 兼容千分制数字输入检验
            if (!this.isNested) {
                const { rowIndex, fieldName: field, widget } = this;
                const value = {
                    type: 'number',
                    rowIndex,
                    field,
                    value: newVal,
                    item: widget,
                };
                this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
            }
            // 将数据抛给上一层，主要是被子表格服务
            this.$emit('change', newVal);
        },
    },
};
</script>
